export const REG_FULL_TRAILING_SLASH = new RegExp('^/+|/+$', 'g');

export const REG_REJECTED_RESET_ERROR = new RegExp('._REJECTED(@@RESET)?$');

export const DIGITS = /\d+/;
export const ONLY_DIGITS = /^\d+$/
export const LETTERS = /[a-zA-Z]+/;
export const UPPERCASE = /[A-Z]+/;
export const LOWERCASE = /[a-z]+/;
export const HOUR_MINUTES = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/

/**
 * Special characters for cognito user pool password. (Does not include + or = as such)
 * @see https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
 */
export const SPECIAL_CHARACTERS = /[`~!@#$%^&*()\-_[{}\]\\|;:'",<.>/?]+/;
